import { useEffect, useState } from "react";

const useDynamicImage = (url: string) => {
  const [src, setSrc] = useState('')

  useEffect(() => {
    import(`@assets/images/${url}`).then((src: typeof import('*.png')) => {
      setSrc(src.default)
    })
  }, [url])

  return { src }
}

export default useDynamicImage;